/**
 @ngdoc service
 @name mapAuditpackTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapAuditpackTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;
            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);
            var requester = requesterData.role.roleType.isProcurer ? "Procurer" : "NonProcurer";

            //Column1
            if(tileFactory.isPrincipal())
            {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('itemId','itemPrincipleURI'));
            }
            else{
                if(requester=='NonProcurer')
                    tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('itemId','itemURI'));
                else
                    tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('itemId','itemPrincipleURI'))
            }

            tileFactory.addFieldToColumn1(tileFactory.field.newField('job'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('auditPackType'));
            var supplier = undefined;
            if(rawTileData.supplierOrgName){
                supplier = rawTileData.supplierOrgName + ' - ' + rawTileData.supplierOrgUnitName;
            }

            //Column2
            tileFactory.addFieldToColumn2({label: objectTilesLabels.supplierOrgName.label, value: supplier});
            tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('procurerOrgUnitName', 'procurerOrgName'));

            //Column3
            tileFactory.addFieldToColumn3(tileFactory.field.newField('dateCreated','dateTime'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('recruitmentStage'));


            if(rawTileData.attributes) {
                tileFactory.addFieldToColumn3(tileFactory.field.newField('attributes'));
            }
            else
            {
                tileFactory.addFieldToColumn3({label: objectTilesLabels.attributes.label, value: '0'});
            }

            //Column4
            if(rawTileData.attributeScore) {
                tileFactory.addFieldToColumn4(tileFactory.field.newField('attributeScore'));
            }
            else {
                tileFactory.addFieldToColumn4({label: objectTilesLabels.attributeScore.label, value: ''});
            }
            tileFactory.addFieldToColumn4(tileFactory.field.newField('auditResult'));
            if(rawTileData.auditScore) {
                tileFactory.addFieldToColumn4(tileFactory.field.newField('auditScore'));
            }
            else {
                tileFactory.addFieldToColumn4({label: objectTilesLabels.auditScore.label, value: ''});
            }

          tileFactory.addStatus(tileFactory.status.newStatus('auditPackProcessingStatus',
            // Green
            [6603],
            // Red
            [6602],
            // Amber
            [6601]
          ));


          return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapAuditpackTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapAuditpackTileService', mapAuditpackTileService);
}());
